import { ExpensesState } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import logger from "../../../../utils/logger";
import { applyExtraReducer } from "../../weather";
import { PayloadAction } from "@reduxjs/toolkit";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { createThunk, DashboardReqBody } from "../crops/selector";
import { ExpensesData } from "@baseTypes/service/dashboard/IExpensesDashboardService";
import { ServerResponse } from "@baseTypes/baseType";
import { dashboardURL } from "@utils/utils";
import urlcat from "urlcat";
import colors from "@infobis/ui-styles-utils/colors";

const initialState: ExpensesState = {
    data: [],
    isApiLoading: true,
    expensesByArticles: false,
    apiError: undefined
}

const log = logger.getLogger("expenses.dash")

const expenseTransformer = async (response: ServerResponse<ExpensesData[]>) => {
    return {
        ...response, data: response.data.map((el: ExpensesData) => {
            if(el.accumulative.title === "СЗР") {
                return {...el,
                    title: "СЗР",
                    color: colors.ELEMENTS_CHARTS_12,
                    color2: colors.ELEMENTS_CHARTS_12,
                    dimension: "Га"
                }
            }
            if(el.accumulative.title === "Удобрения") {
                return {...el,
                    title: "Удобрения",
                    color: colors.ELEMENTS_CHARTS_6,
                    color2: colors.ELEMENTS_CHARTS_6,
                    dimension: "Га"
                }
            }
            if(el.accumulative.title === "Семена") {
                return {...el,
                    title: "Семена",
                    color: colors.ELEMENTS_CHARTS_14,
                    color2: colors.ELEMENTS_CHARTS_14,
                    dimension: "Га"
                }
            }
            return el
        })
    }
}

const fetchExpenses = createThunk<ExpensesData[], DashboardQueryParams, DashboardReqBody>()(
    { url: dashboardURL('costs'), transformer: expenseTransformer, method: "POST" },
    (payload, url) => ({
        url: urlcat(url, {year: payload.year}),
        data: { cropRotationIds: payload.cropRotationIds || [] }
    })
)

const expensesSlice = createSlice({
    name: 'expensesSlice',
    initialState,
    reducers: {
        toggleExpensesByArticles(state: ExpensesState, action: PayloadAction<{ enabled: boolean }>) {
            state.expensesByArticles = action.payload.enabled
        }
    },
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchExpenses)
    },
})

export const actions = { ...expensesSlice.actions, fetchExpenses }
export default expensesSlice.reducer
// export default ndviDashboardSlice.reducer
// export default function expensesReducer(state = initialState, action: ExpensesAction): ExpensesState {
//
//   switch (action.type) {
//     case ExpensesActionEnum.FETCH_LIST_OF_EXPENSES_FOR_DASH :
//       return {
//         ...state,
//         listOfExpensesForExpensesDash: Object.assign([],action.payload)
//       }
//
//     case ExpensesActionEnum.IS_LOADING_EXPENSES_DASH:
//       return {
//         ...state,
//         isLoadingExpensesDash: action.payload
//       }
//
//
//     case ExpensesActionEnum.ERROR_IN_EXPENSES_DASH:
//       return {
//         ...state,
//         errorInExpensesDash: action.payload
//       }
//
//     default:
//       return state;
//   }
// }
